const getAllAppUrls = (soulApiRequest) => async () => {
  const response = await soulApiRequest({
    url: '/auth0-config/app-urls',
    method: 'get'
  });
  return response.data.appUrls;
};

export default getAllAppUrls;
